import React from "react";
import styled from "styled-components";
import * as R from "ramda";
import * as u from "../utils";
import * as I from "./Icons";

export default function Select(props) {
  const menuRef = React.useRef();
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(attachOutsideClick, [isOpen]);

  return (
    <S.Container ref={menuRef} data-cy={`${props.name}-select`}>
      <S.InnerContainer>
        <S.Placeholder onClick={() => setIsOpen((curent) => !curent)}>
          {props.value || props.placeholder || ""}
          <I.ArrowDown />
        </S.Placeholder>
        {!props.isDisabled && isOpen && (
          <S.OptionsContainer shouldScroll={props.shouldScroll}>
            {getMaybeOptions()}
          </S.OptionsContainer>
        )}
      </S.InnerContainer>
    </S.Container>
  );

  function getMaybeOptions() {
    const noOpts = R.isEmpty(props.opts) || !props.opts;
    if (noOpts) return getEmptyMessage();
    return props.opts.map(getOption);
  }

  function getOption(elm) {
    const onClick = () => {
      props.onSelect(elm);
      setIsOpen(false);
    };

    const subProps = {
      key: elm,
      onClick,
    };

    return <S.Option {...subProps}>{elm}</S.Option>;
  }

  function getEmptyMessage() {
    return <S.EmptyMesssage>No options</S.EmptyMesssage>;
  }

  function attachOutsideClick() {
    if (!isOpen) return;
    document.addEventListener("click", onMaybeOutside);

    return () => document.removeEventListener("click", onMaybeOutside);

    function onMaybeOutside(evt) {
      if (menuRef?.current?.contains(evt.target)) return;
      setIsOpen(false);
    }
  }
}

const S = {};

S.Container = styled.div`
  flex: 1;
  margin-bottom: 20px;
`;

S.InnerContainer = styled.div`
  position: relative;
`;

S.Placeholder = styled.div`
  align-items: center;
  background-color: white;
  border: 1px solid ${u.colours.shellOverlay};
  border-radius: 5px;
  color: ${u.colours.charcoal};
  display: flex;
  font-size: 15px;
  height: 59px;
  letter-spacing: 0.5px;
  outline: none;
  padding: 0 20px 0 16px;
  justify-content: space-between;
  :hover {
    cursor: pointer;
  }
`;

S.OptionsContainer = styled.ul`
  background-color: white;
  border: 0.5px solid rgba(16, 22, 26, 0.15);
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 60px;
  width: 100%;
  z-index: 1;
  ${(p) =>
    p.shouldScroll &&
    `
    max-height: 250px;
    overflow: auto;
    
    /* width */
    &::-webkit-scrollbar {
      width: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #F1F1F1;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: ${u.colours.teal};
      border-radius: 50px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #05AAA4;
    }
  `}
`;

S.Option = styled.div`
  align-items: center;
  display: flex;
  font-size: 15px;
  height: 50px;
  padding: 9px;
  :hover {
    background-color: ${u.colours.shellOverlay};
    cursor: pointer;
  }
`;

S.EmptyMesssage = styled.div`
  align-items: center;
  color: rgb(152, 152, 152);
  display: flex;
  font-size: 12px;
  height: 50px;
  justify-content: center;
`;
